<app-confirm-dialog
  [visible]="true"
  [maxWidthRem]="40"
  icon="edit"
  iconTon="akzent"
  confirmColor="primary"
  [title]="(isLibrary() ? 'objectMappings.rename.titleLibrary' : 'objectMappings.rename.titleEntry') | translate"
  [message]="'objectMappings.rename.message' | translate: { name: currentName() }"
  [confirmLabel]="'objectMappings.rename.confirm' | translate"
  [cancelLabel]="'objectMappings.rename.cancel' | translate"
  [busy]="applying()"
  [confirmDisabled]="!canApply()"
  (confirmed)="apply()"
  (cancelled)="cancelled.emit()"
>
  <form class="ord-form" (submit)="$event.preventDefault(); requestPreview()">
    <mat-form-field
      appearance="fill"
      floatLabel="always"
      subscriptSizing="dynamic"
      class="ord-field tc-field tc-field--uppercase-label"
      [class.ord-field--error]="!!nameError()"
    >
      <mat-label>{{ 'objectMappings.rename.newName' | translate }}</mat-label>
      <input
        #nameInput
        matInput
        class="ord-mono"
        data-testid="ord-name"
        autocomplete="off"
        [value]="name()"
        [attr.maxlength]="fieldLengths.NAME_MAX"
        [attr.aria-invalid]="!!nameError()"
        [attr.aria-describedby]="nameError() ? 'ord-name-error' : null"
        (input)="onNameInput($event)"
        (blur)="onNameBlur()"
      />
    </mat-form-field>
    <button
      mat-stroked-button
      type="submit"
      class="ord-preview"
      data-testid="ord-preview"
      [disabled]="previewLoading() || applying()"
    >
      {{ 'objectMappings.rename.preview' | translate }}
    </button>
  </form>
  @if (nameError(); as problem) {
    <p id="ord-name-error" class="ord-hint ord-hint--error" data-testid="ord-name-error">
      {{ 'objectMappings.rename.' + problem | translate }}
    </p>
  }

  @if (previewLoading()) {
    <div class="ord-loading" data-testid="ord-loading" role="status">
      <mat-spinner diameter="24" />
      <span>{{ 'objectMappings.rename.previewLoading' | translate }}</span>
    </div>
  }
  @if (error(); as message) {
    <p class="ord-hint ord-hint--error" role="alert" data-testid="ord-error">{{ message }}</p>
  }

  @if (preview(); as result) {
    <app-object-usage-list
      class="ord-usages"
      [usages]="result.usages"
      [projectId]="projectId()"
      [rename]="{ oldName: result.oldName, newName: result.newName }"
    />
    @if (result.notTouched.length > 0) {
      <div class="ord-not-touched" data-testid="ord-not-touched">
        <p class="ord-hint">{{ 'objectMappings.rename.notTouched' | translate }}</p>
        <ul class="ord-not-touched__lines">
          @for (line of result.notTouched; track $index) {
            <li>
              @if (line.lineNumber !== null) {
                <span class="ord-not-touched__number">
                  {{ 'objectMappings.usages.line' | translate }} {{ line.lineNumber }}
                </span>
              }
              <code>{{ line.text ?? line.reference }}</code>
            </li>
          }
        </ul>
      </div>
    }
  }
</app-confirm-dialog>
